module.exports = "/images/accept-payments.png?ebcf3207f3353c4ce4f14eae37343714";